import { setDataAtrOnlyInTests } from "~/solidJs/shared/helpers/testHelpers";

/**
 * Create div element with className optionally inside parent
 */
export const $div = (className = "", parentElement: HTMLElement | null = null) => {
	const domElement = document.createElement("div");
	domElement.className = className;

	if (parentElement) {
		parentElement.append(domElement);
	}

	return domElement;
};

export const $buttonComponent = (
	parentElement: HTMLElement | null = null,
	textContent?: string,
	icon?: () => HTMLElement
) => {
	const domElement = document.createElement("button");
	domElement.className =
		"py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-white text-gray-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 transition-all text-2xs dark:focus:ring-offset-gray-800";

	if (textContent) {
		domElement.textContent = textContent;
	}
	if (icon) {
		const iconC = icon();
		domElement.append(iconC);
	}
	if (parentElement) {
		parentElement.append(domElement);
	}

	return domElement;
};

/**
 * Create modalView inside body element
 */
export const $modalView = (
	contentDomElement: HTMLElement | Element,
	autoCloseInit = false,
	clearOtherModalViews = false,
	remOnClose = true,
	onCloseCallback?: () => void,
	isNeedToStopPropagation = true,
	isNeedToClose?: () => boolean
) => {
	if (clearOtherModalViews) {
		const modalViews = document.querySelectorAll("#modal-view");
		modalViews.forEach((modal) => {
			modal.classList.add("hidden");
		});
	}

	const container = $div("modal-view", document.body);
	setDataAtrOnlyInTests(() => {
		container.setAttribute("data-test", "modal-view");
	});
	container.append(contentDomElement);
	const closeOnKeyDown = (e: KeyboardEvent) => {
		if (e.which === 27) {
			e.preventDefault();
			close();
		}
	};
	const closeModalBtn = container.querySelector(".close");
	const close = () => {
		if (isNeedToClose && !isNeedToClose()) return;
		container.removeEventListener("click", close);
		closeModalBtn?.removeEventListener("click", close);
		contentDomElement.removeEventListener("click", stopPropagationClick);
		if (remOnClose) {
			contentDomElement.classList.add("hidden");
			document.body.append(contentDomElement);
			container.remove();
			document.removeEventListener("keydown", closeOnKeyDown);
			onCloseCallback?.();
			return;
		}
		container.classList.add("hidden");
		onCloseCallback?.();
	};

	document.addEventListener("keydown", closeOnKeyDown);
	container.addEventListener("click", close);
	const stopPropagationClick = (e: Event) => {
		e.stopPropagation();
	};
	isNeedToStopPropagation && contentDomElement.addEventListener("click", stopPropagationClick);
	if (autoCloseInit) {
		const cross = $div("close", container);

		cross.addEventListener("click", close);
	}

	closeModalBtn?.addEventListener("click", close);

	return {
		domElement: container,
		close
	};
};

export function hideAllModals() {
	const modals = document.querySelectorAll(".modal-view");
	modals.forEach((modal) => {
		modal.classList.add("hidden");
	});
}
